import React, { useState } from "react";
import convertId from "../../utilities/convert-id";
import { graphql, Link } from "gatsby";
import Content from "../utilities/content";
import CmsImage from "../utilities/cms-image";
import { Navigation, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import FsLightbox from "fslightbox-react";

const FullWidthImageCarousel = ({ data }) => {
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });

  const [forceUpdate, setForceUpdate] = useState(false);

  function openLightboxOnSlide(number) {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number,
    });
  }

  const productImages = data.images.map(
    (image) => image.image?.localFile.publicURL
  );

  return (
    <>
      <section
        id={convertId(data.name)}
        className={`section-full-width-image-carousel section clipped-small-top bg-white`}
      >
        <div className="container mb-5">
          <div className="text-center">
            {data.title && (
              <Content className="carousel-title display-5 tk-rift text-uppercase text-primary">
                {data.title}
              </Content>
            )}
            {data.description && (
              <Content className="carousel-description lead text-secondary fw-bold">
                {data.description}
              </Content>
            )}
          </div>
        </div>
        {data.images && data.images.length > 0 && (
          <div className="swiper-container">
            <Swiper
              modules={[Navigation, Autoplay]}
              className="swiper-carousel"
              slidesPerView={1}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              breakpoints={{
                768: { slidesPerView: 3 },
              }}
              loop
              loopAdditionalSlides={data.images.length - 1}
              autoplay={{
                delay: 1000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
              }}
              speed={1000}
            >
              {data.images.map((slide, index) => {
                return (
                  <SwiperSlide key={slide.index}>
                    <div
                      role="button"
                      className="d-block"
                      onClick={() => openLightboxOnSlide(index + 1)}
                    >
                      {slide.image && (
                        <div className="ratio ratio-carousel-image ratio-4x3">
                          <div className="h-100">
                            <CmsImage
                              className="img-fluid w-100 mx-auto d-block h-100"
                              image={slide.image}
                              quality={100}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </SwiperSlide>
                );
              })}
              <div className="swiper-button-prev" />
              <div className="swiper-button-next" />
            </Swiper>
          </div>
        )}
      </section>
      <FsLightbox
        toggler={lightboxController.toggler}
        sources={productImages}
        slide={lightboxController.slide}
      />
    </>
  );
};

export const query = graphql`
  fragment FullWidthImageCarousel on WpPage_Sections_Sections_FullWidthImageCarousel {
    fieldGroupName
    name
    hideSection
    title
    description
    images {
      image {
        altText
        localFile {
          extension
          publicURL
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`;

export default FullWidthImageCarousel;
